import { Box, Button, Flex, Heading, Stack, Text, useToast } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { useVerificationFlow } from '../../../../../../../shared/VerificationFlow'
import { useRemovePartnerStep } from '../../../../../../../../hooks/homebotNetwork/verificationFlow/useRemovePartnerStep'

const MSG = defineMessages({
  cancel: {
    id: 'VerificationFlow.RemovePartnerConfirmation.cancel',
    defaultMessage: 'Cancel'
  },
  descriptionLO: {
    id: 'VerificationFlow.RemovePartnerConfirmation.descriptionLO',
    defaultMessage: 'Are you sure you want to remove this loan officer?'
  },
  descriptionREA: {
    id: 'VerificationFlow.RemovePartnerConfirmation.descriptionREA',
    defaultMessage: 'Are you sure you want to remove this real estate agent?'
  },
  error: {
    id: 'VerificationFlow.RemovePartnerConfirmation.error',
    defaultMessage: 'Failed to remove partner'
  },
  remove: {
    id: 'VerificationFlow.RemovePartnerConfirmation.remove',
    defaultMessage: 'Yes, remove'
  },
  removePartner: {
    id: 'VerificationFlowModal.removePartner',
    defaultMessage: 'Remove {customerType}?'
  }
})
/**
 * Remove partner view specifically for the schedule tour flow
 *
 * @returns RemovePartnerView
 */
export const RemovePartnerView = () => {
  const intl = useIntl()
  const { state } = useVerificationFlow()
  const toast = useToast()
  const { currentPartnerType } = state
  const { onCancel, removePartner, isLoading } = useRemovePartnerStep()

  const title = intl.formatMessage(MSG.removePartner, {
    customerType: currentPartnerType === 'LoanOfficer' ? 'Loan Officer' : 'Real Estate Agent'
  })

  const description =
    currentPartnerType === 'LoanOfficer'
      ? intl.formatMessage(MSG.descriptionLO)
      : intl.formatMessage(MSG.descriptionREA)

  const onRemove = async () => {
    try {
      await removePartner()
    } catch (error) {
      toast({
        description: intl.formatMessage(MSG.error),
        status: 'error'
      })
    }
  }

  return (
    <>
      <Box>
        <Heading textAlign='left'>{title}</Heading>
        <Text color='neutral.700'>{description}</Text>
      </Box>
      <Stack direction='row' gap={2} justifyContent='flex-end' mt='6'>
        <Button
          onClick={onCancel}
          tracking={{
            guid: 'fHgUXfN5vcQ1ida2D5SPCs',
            ui_context: 'schedule_tour_verification_flow_remove_partner_view',
            descriptor: MSG.cancel.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.cancel)}
        </Button>
        <Button
          colorScheme='danger'
          isLoading={isLoading}
          onClick={onRemove}
          tracking={{
            guid: 'btMWmnazME7ojtyMm3Pupq',
            ui_context: 'schedule_tour_verification_flow_remove_partner_view',
            descriptor: MSG.remove.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.remove)}
        </Button>
      </Stack>
    </>
  )
}
